export const KEYWORDS_MOVED_UP = "activation.homepage.widget.rank_tracker.keywords_moved_up";
export const KEYWORDS_DECLINING = "activation.homepage.widget.rank_tracker.keywords_declining";
export const RANKS_WOW = "activation.homepage.widget.rank_tracker.ranks_wow";
